import React, { Component, Fragment } from 'react';
import { unmountComponentAtNode } from "react-dom";
import 'vagaro-website-rendering/src/components/Styles/page.content.css';
import { AsyncAjaxGet } from "components/Common/AsyncAjaxService";
import { ResponseCode, utils } from "utils/Utils";
import VGPopUp from "components/Controls/VGPopUp";
import StaticRender from 'components/WebDesigner/StaticRender';
import { DefaultSiteData } from 'components/WebDesigner/Data/SiteData';
import { ScreenSize } from 'vagaro-website-rendering/src/components/Definitions/ScreenSize';
import { DesktopIcon, MobileIcon, TabletIcon } from "../WebDesigner/Icons/ScreenSizeIcons";
import styled from 'styled-components';
import { setStyleDenotation } from 'components/SetLibrary/SetUtils';
import {CreateSiteStylingFromString} from 'components/SetLibrary/SetUtils';
const VagaroAPIEnum = {
    LayoutPreview: "LayoutPageFile/layoutpreview",
    StylePreview: "style/getsitestyling?StyleID=",
}

export default class Pages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            AccessToken: props.AccessToken,
            BusinessId: props.BusinessId,
            layoutId: props.LayoutId,
            styleId: props.StyleId,
            layoutimage: props.Layoutimage,
            siteData: null,
            isComplete: false,
            screenSize: ScreenSize.Desktop,
            IsModifyAllowed : props.IsModifyAllowed
        }
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        let contentdata = [];
        //create temporary siteData to pass to static render
        let siteData = { ...DefaultSiteData };
        //create new siteStyling so the default siteStyling is not overwritten durring load
        siteData.siteStyling = { ...DefaultSiteData.siteStyling };

        //load layout
        await AsyncAjaxGet(
            VagaroAPIEnum.LayoutPreview + "?layoutId=" + this.state.layoutId,
            this.state.AccessToken,
            function onSuccess(data) {
           
                try {
                    if (
                        data != null &&
                        data.data != null &&
                        data.data.responseCode == ResponseCode.Success
                    ) {
                        if (data != null && data.data != null && data.data.data != null) {
                            contentdata = data.data.data;
                        }
                        else {
                            contentdata = [];
                        }
                    }
                    else {
                        contentdata = [];
                    }
                }
                catch (error) {

                }
            },
            function OnError() {

            }
        );

        console.log(this.state);
        //load style
            if(this.state.styleId.includes(setStyleDenotation)){ // if coming from set combination create style from set ids.
                const userContext = { ...DefaultSiteData.userContext }; // create valid userContext object using default values
                userContext.businessId = this.state.BusinessId;
                userContext.accessToken = this.state.AccessToken;
                const newSiteData = this.state.siteData;
                await CreateSiteStylingFromString(userContext,this.state.styleId,(data)=>{
                    siteData.siteStyling = data;
                    siteData.imageUrls = siteData.siteStyling.imageMapping;
                },(error)=>{})
            }
            else{
        await AsyncAjaxGet(
            VagaroAPIEnum.StylePreview + this.state.styleId,
            this.state.AccessToken,
            function onSuccess(data) {

              
                try {
                    if (
                        data != null &&
                        data.data != null &&
                        data.data.responseCode == ResponseCode.Success
                    ) {
                        if (data != null && data.data != null && data.data.data != null) {

                            try {
                                let parsed = JSON.parse(data.data.data.siteStyling);

                                siteData.siteStyling = parsed.styling;
                            
                                siteData.imageUrls = parsed.imageUrls;

                             
                            }
                            catch (error) {

                            }
                        }

                    }

                }
                catch (error) {

                }
            },
            function OnError() {

            }
        );
        }

        this.setState({ content: contentdata, siteData: siteData, isComplete: true });
    }

    PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    UseLayout = (layoutID) => {
        if (typeof layoutID !== 'undefined' && layoutID !== null && layoutID !== "") {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + this.state.styleId + "/" + layoutID + "/designer";
            a.click();
        }
    };

    UseWebsiteLayout = () => {
        if (typeof this.state.layoutId !== 'undefined' && this.state.layoutId !== null && this.state.layoutId !== "") {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + this.state.styleId + "/" + this.state.layoutId + "/designer";
            a.click();
        }
    };

    render() {

        const { content, isComplete } = this.state;

        let layoutRoot = null;
        try {
            layoutRoot = JSON.parse(content);
        }
        catch (error) {
            layoutRoot = null;
        }
        
        const userContext = { ...DefaultSiteData.userContext }; // create valid userContext object using default values
        userContext.businessId = this.state.BusinessId;
        userContext.sitebid = this.state.BusinessId;
        userContext.accessToken = this.state.AccessToken;
        const newSiteData = this.state.siteData;
  
        userContext.imageMapping = newSiteData?.siteStyling?.imageMapping??[];

        const previewURL = window.location.origin+"/preview/"+this.state.styleId+"/"+this.state.layoutId+"/demo";
      


        const maxWidth = this.state.screenSize == ScreenSize.Desktop ? "100%" : this.state.screenSize == ScreenSize.Tablet ? "770px" : "375px";
        return (
            (typeof content != 'undefined' && content != null && content != '' && content != "") ?
                <Fragment>
                    <VGPopUp
                        id={"PreviewBusinessStylePopup"}
                        show={true}
                        onHide={this.PopupClose}
                        title={"Preview"}
                        dialogClassName="webbuilder-preivew-style"
                        body={
                            <div className="style-priview-wrapper" style={{ maxWidth: "100%" }}>
                                <div className="flex-row center-all" style={{ marginBottom: "12px" }}>

                                    <button className={"desktop preview-option center-all invisible-button " + (this.state.screenSize == ScreenSize.Desktop ? "selected" : "")} onClick={() => this.setState({ screenSize: ScreenSize.Desktop })} ><DesktopIcon /></button>
                                    <button className={"tablet preview-option center-all invisible-button " + (this.state.screenSize == ScreenSize.Tablet ? "selected" : "")} onClick={() => this.setState({ screenSize: ScreenSize.Tablet })} ><TabletIcon /></button>
                                    <button className={"mobile preview-option center-all invisible-button " + (this.state.screenSize == ScreenSize.Mobile ? "selected" : "")} onClick={() => this.setState({ screenSize: ScreenSize.Mobile })} ><MobileIcon /></button>

                                </div>
                                <div className="style-priview-parent">
                                    <div className="style-priview" style={{ maxWidth: maxWidth }}>
                                        {utils.Validate(content) && layoutRoot != null &&
                                            <>
                                             <StaticRender root={layoutRoot} siteData={newSiteData} userContext={userContext} />
                                            {/* <iframe className='w-full h-full ' style={{minHeight:"70vh"}} src={previewURL}></iframe> */}
                                           
                                            </>
                                        }
                                    </div>
                                </div>

                            </div>
                        }
                        footer={
                            <Fragment>
                                <button className="w-button w-button-secondary" onClick={() => this.PopupClose()}>Cancel</button>
                                <button className={"w-button w-button-primary layout-"+this.state.layoutId} onClick={() => this.UseWebsiteLayout()}>Use Website Layout</button>
                            </Fragment >
                        }
                        isRemoveTabModalIndex={false}
                        isShowFooter={true}
                        size={"md"}
                        backdrop={true}
                    />
                </Fragment>
                : isComplete ?
                    <Fragment>
                        <VGPopUp
                            id={"PreviewBusinessStylePopup"}
                            show={true}
                            onHide={this.PopupClose}
                            title={"Message"}
                            dialogClassName="cancelauto-renew-alert"
                            body={
                                <div className="alertContent">
                                    <p>Businesses have not created a home page or published design. Please set the default home page and published layout.</p>
                                </div>
                            }
                            footer={
                                <Fragment>
                                    <button className="w-button w-button-primary" onClick={() => this.PopupClose()}>OK</button>
                                </Fragment >
                            }
                            isRemoveTabModalIndex={false}
                            isShowFooter={true}
                            size={"md"}
                            backdrop={true}
                        />
                    </Fragment> : <></>

        );
    }
}
